@if (lockBeaconConfig) {
  <!-- Read-only (Devices Read): nothing inside can be used, and the add and save buttons are hidden -->
  <div [attr.inert]="readOnly ? '' : null" data-testid="lock-beacon-settings">
    @if (user && user.roleLevel === 200) {
      <div class="mb-3">
        <strong>DoorID: {{ lockBeaconConfig.doorId }}</strong>
      </div>
    }
    <form
      [formGroup]="lockBeaconForm"
      (ngSubmit)="submitLockBeaconSettings()"
      [hidden]="isOldDevice()"
      >
      <div class="form-group">
        <label>{{ "CLOSE_DOOR_FOR_UNKNOWN" | translate }}</label>
        <section>
          <mat-slide-toggle
            formControlName="closeDoorForUnknownButton"
            (change)="closeDoorForUnknownButtonChange($event)"
            >
          </mat-slide-toggle>
        </section>
      </div>
      <div class="form-group">
        <label>{{ "OPEN_DOOR_FOR_UNKNOWN" | translate }}</label>
        <section>
          <mat-slide-toggle
            formControlName="openDoorForUnknownButton"
            (change)="openDoorForUnknownButtonChange($event)"
            >
          </mat-slide-toggle>
        </section>
      </div>
      <div class="form-group">
        <label>{{ "ALERT_WHEN_BUTTON_IN_LOCK_AREA" | translate }}</label>
        <section>
          <mat-slide-toggle formControlName="alertWhenButtonInLockArea">
          </mat-slide-toggle>
        </section>
      </div>
    </form>
    <form #allowedDeniedForm="ngForm">
      <div>
        <strong>{{ "ALLOWED_DEVICES" | translate }}</strong>
        <div class="mt-3 mb-3">
          <ngx-bootstrap-multiselect
            class="d-inline"
            [texts]="multiselect.textDev"
            [options]="multiselect.allowedDeviceList"
            [settings]="multiselect.settingsDev"
            [(ngModel)]="addNewAllowedDeviceArray"
            name="addNewAllowedDeviceDrp"
          ></ngx-bootstrap-multiselect>
          @if (!readOnly) {
          <button
            type="button"
            class="btn btn-outline-primary d-inline ml-3"
            (click)="addNewAllowedDevice()"
            >
            <span class="fal fa-fw fa-plus"></span>
            {{ "ADD_NEW" | translate }}
          </button>
          }
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 25%">{{ "NAME" | translate }}</th>
              <th style="width: 25%">{{ "WEEKDAYS" | translate }}</th>
              <th style="width: 25%">
                {{ "SATURDAYS" | translate }}
              </th>
              <th style="width: 25%">{{ "SUNDAYS" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (
              allowedDevice of lockBeaconConfig.allowedDevices
              ; track
              allowedDevice) {
              <tr
                [ngClass]="{ lostDevice: allowedDevice.lostDevice }"
                >
                <td>
                  <div>
                    {{
                    allowedDevice.name
                    ? allowedDevice.name +
                    " (" +
                    allowedDevice.id +
                    ")"
                    : allowedDevice.id
                    }}
                  </div>
                  <div class="mt-1">
                    <span
                      class="fal fa-fw fa-trash-alt cursorPointerHover mr-3"
                                    (click)="
                                        removeAllowedDeviceFromList(
                                            allowedDevice
                                        )
                                    "
                                    matTooltip="{{
                                        'REMOVE_DEVICE' | translate
                                    }}"
                      [matTooltipPosition]="'above'"
                    ></span>
                    @if (!isOldDevice()) {
                      <span
                        class="fal fa-fw cursorPointerHover mr-3"
                                    (click)="
                                        allowedDevice.lostDevice =
                                            !allowedDevice.lostDevice
                                    "
                                    [ngClass]="
                                        allowedDevice.lostDevice
                                            ? 'fa-check'
                                            : 'fa-ban'
                                    "
                                    matTooltip="{{
                                        allowedDevice.lostDevice
                                            ? ('MARK_AS_FOUND' | translate)
                                            : ('MARK_AS_LOST' | translate)
                                    }}"
                        [matTooltipPosition]="'above'"
                      ></span>
                    }
                    <span
                      class="fal fa-fw fa-edit cursorPointerHover mr-1"
                                    (click)="
                                        allowedDevice.editMode =
                                            !allowedDevice.editMode
                                    "
                      matTooltip="{{ 'EDIT_TIMES' | translate }}"
                      [matTooltipPosition]="'above'"
                    ></span>
                    @if (
                      allowedDevice.validityTimes.length <
                      2 && !isOldDevice()
                      ) {
                      <span
                        (click)="addNewTimeToDevice(allowedDevice)"
                        class="fal fa-fw fa-plus cursorPointerHover"
                                    matTooltip="{{
                                        'ADD_NEW_TIME' | translate
                                    }}"
                        [matTooltipPosition]="'above'"
                      ></span>
                    }
                    @if (
                      allowedDevice.validityTimes.length ===
                      2 && !isOldDevice()
                      ) {
                      <span
                        class="fal fa-fw fa-minus-circle cursorPointerHover"
                                    (click)="
                                        allowedDevice.validityTimes.splice(1, 1)
                                    "
                        matTooltip="{{ 'REMOVE_TIME' | translate }}"
                        [matTooltipPosition]="'above'"
                      ></span>
                    }
                  </div>
                </td>
                <td>
                  @for (
                    times of allowedDevice.validityTimes; track
                    times; let i = $index) {
                    <div
                      class="mb-2"
                      >
                      @if (!allowedDevice.editMode) {
                        <div>
                          @if (
                            convertTimesToType(
                            times.weekDaysFrom,
                            times.weekDaysTo
                            ) === '0'
                            ) {
                            <span
                              >{{ "ALWAYS" | translate }}</span
                              >
                            }
                            @if (
                              convertTimesToType(
                              times.weekDaysFrom,
                              times.weekDaysTo
                              ) === '1'
                              ) {
                              <span
                                >{{ "NEVER" | translate }}</span
                                >
                              }
                              @if (
                                convertTimesToType(
                                times.weekDaysFrom,
                                times.weekDaysTo
                                ) === '2'
                                ) {
                                <span
                                  >{{ times.weekDaysFrom }} -
                                  {{ times.weekDaysTo }}</span
                                  >
                                }
                              </div>
                            }
                            @if (allowedDevice.editMode) {
                              <div
                                class="form-inline timeEditInputs"
                                >
                                <div>
                                  <mat-form-field>
                                    <mat-label>{{
                                      "SELECT_ACTIVE_TIME" | translate
                                    }}</mat-label>
                                    <mat-select
                                                [value]="
                                                    convertTimesToType(
                                                        times.weekDaysFrom,
                                                        times.weekDaysTo
                                                    )
                                                "
                                                (selectionChange)="
                                                    changeValidityTime(
                                                        $event,
                                                        times,
                                                        'weekDays'
                                                    )
                                                "
                                      >
                                      <mat-option value="0">{{
                                        "ALWAYS" | translate
                                      }}</mat-option>
                                      <mat-option value="1">{{
                                        "NEVER" | translate
                                      }}</mat-option>
                                      <mat-option value="2">{{
                                        "DURING_TIMES" | translate
                                      }}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                @if (
                                  convertTimesToType(
                                  times.weekDaysFrom,
                                  times.weekDaysTo
                                  ) === '2'
                                  ) {
                                  <div
                                    class="mb-3"
                                    >
                                    <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'weekDaysFrom')" (ngModelChange)="setTimeFromDate(times, 'weekDaysFrom', $event)" [name]="'allowedWeekDaysFrom' + i">-->
                                    <input
                                      class="form-control form-control-sm"
                                            [matTimepicker]="
                                                allowedWeekDaysFrom
                                            "
                                      [ngModel]="getTimeAsDate(times, 'weekDaysFrom')" (ngModelChange)="setTimeFromDate(times, 'weekDaysFrom', $event)"
                                            [name]="
                                                'allowedWeekDaysFrom' +
                                                i +
                                                allowedDevice.id
                                            "
                                      />
                                      <mat-timepicker
                                        #allowedWeekDaysFrom
                                        interval="10m"
                                      ></mat-timepicker>
                                      <span class="mr-2 ml-2">-</span>
                                      <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'weekDaysTo')" (ngModelChange)="setTimeFromDate(times, 'weekDaysTo', $event)" [name]="'allowedWeekDaysTo' + i">-->
                                      <input
                                        class="form-control form-control-sm"
                                        [matTimepicker]="allowedWeekDaysTo"
                                          [ngModel]="getTimeAsDate(times, 'weekDaysTo')" (ngModelChange)="setTimeFromDate(times, 'weekDaysTo', $event)"
                                            [name]="
                                                'allowedWeekDaysTo' +
                                                i +
                                                allowedDevice.id
                                            "
                                        />
                                        <mat-timepicker
                                          #allowedWeekDaysTo
                                          interval="10m"
                                        ></mat-timepicker>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </td>
                          <td>
                            @for (
                              times of allowedDevice.validityTimes; track
                              times; let i = $index) {
                              <div
                                class="mb-2"
                                >
                                @if (!allowedDevice.editMode) {
                                  <div>
                                    @if (
                                      convertTimesToType(
                                      times.saturdaysFrom,
                                      times.saturdaysTo
                                      ) === '0'
                                      ) {
                                      <span
                                        >{{ "ALWAYS" | translate }}</span
                                        >
                                    }
                                    @if (
                                      convertTimesToType(
                                      times.saturdaysFrom,
                                      times.saturdaysTo
                                      ) === '1'
                                      ) {
                                      <span
                                        >{{ "NEVER" | translate }}</span
                                        >
                                      }
                                      @if (
                                        convertTimesToType(
                                        times.saturdaysFrom,
                                        times.saturdaysTo
                                        ) === '2'
                                        ) {
                                        <span
                                          >{{ times.saturdaysFrom }} -
                                          {{ times.saturdaysTo }}</span
                                          >
                                        }
                                      </div>
                                    }
                                    @if (allowedDevice.editMode) {
                                      <div
                                        class="form-inline timeEditInputs"
                                        >
                                        <div>
                                          <mat-form-field>
                                            <mat-label>{{
                                              "SELECT_ACTIVE_TIME" | translate
                                            }}</mat-label>
                                            <mat-select
                                                [value]="
                                                    convertTimesToType(
                                                        times.saturdaysFrom,
                                                        times.saturdaysTo
                                                    )
                                                "
                                                (selectionChange)="
                                                    changeValidityTime(
                                                        $event,
                                                        times,
                                                        'saturdays'
                                                    )
                                                "
                                              >
                                              <mat-option value="0">{{
                                                "ALWAYS" | translate
                                              }}</mat-option>
                                              <mat-option value="1">{{
                                                "NEVER" | translate
                                              }}</mat-option>
                                              <mat-option value="2">{{
                                                "DURING_TIMES" | translate
                                              }}</mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        @if (
                                          convertTimesToType(
                                          times.saturdaysFrom,
                                          times.saturdaysTo
                                          ) === '2'
                                          ) {
                                          <div
                                            class="mb-3"
                                            >
                                            <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'saturdaysFrom')" (ngModelChange)="setTimeFromDate(times, 'saturdaysFrom', $event)" [name]="'allowedSaturdaysfrom' + i">-->
                                            <input
                                              class="form-control form-control-sm"
                                            [matTimepicker]="
                                                allowedSaturdaysfrom
                                            "
                                                      [ngModel]="getTimeAsDate(times, 'saturdaysFrom')" (ngModelChange)="setTimeFromDate(times, 'saturdaysFrom', $event)"
                                            [name]="
                                                'allowedSaturdaysfrom' +
                                                i +
                                                allowedDevice.id
                                            "
                                              />
                                              <mat-timepicker
                                                #allowedSaturdaysfrom
                                                interval="10m"
                                              ></mat-timepicker>
                                              <span class="mr-2 ml-2">-</span>
                                              <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'saturdaysTo')" (ngModelChange)="setTimeFromDate(times, 'saturdaysTo', $event)" [name]="'allowedSaturdaysTo' + i">-->
                                              <input
                                                class="form-control form-control-sm"
                                                [matTimepicker]="allowedSaturdaysTo"
                                                          [ngModel]="getTimeAsDate(times, 'saturdaysTo')" (ngModelChange)="setTimeFromDate(times, 'saturdaysTo', $event)"
                                            [name]="
                                                'allowedSaturdaysTo' +
                                                i +
                                                allowedDevice.id
                                            "
                                                />
                                                <mat-timepicker
                                                  #allowedSaturdaysTo
                                                  interval="10m"
                                                ></mat-timepicker>
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                  </td>
                                  <td>
                                    @for (
                                      times of allowedDevice.validityTimes; track
                                      times; let i = $index) {
                                      <div
                                        class="mb-2"
                                        >
                                        @if (!allowedDevice.editMode) {
                                          <div>
                                            @if (
                                              convertTimesToType(
                                              times.sundaysFrom,
                                              times.sundaysTo
                                              ) === '0'
                                              ) {
                                              <span
                                                >{{ "ALWAYS" | translate }}</span
                                                >
                                            }
                                            @if (
                                              convertTimesToType(
                                              times.sundaysFrom,
                                              times.sundaysTo
                                              ) === '1'
                                              ) {
                                              <span
                                                >{{ "NEVER" | translate }}</span
                                                >
                                              }
                                              @if (
                                                convertTimesToType(
                                                times.sundaysFrom,
                                                times.sundaysTo
                                                ) === '2'
                                                ) {
                                                <span
                                                  >{{ times.sundaysFrom }} -
                                                  {{ times.sundaysTo }}</span
                                                  >
                                                }
                                              </div>
                                            }
                                            @if (allowedDevice.editMode) {
                                              <div
                                                class="form-inline timeEditInputs"
                                                >
                                                <div>
                                                  <mat-form-field>
                                                    <mat-label>{{
                                                      "SELECT_ACTIVE_TIME" | translate
                                                    }}</mat-label>
                                                    <mat-select
                                                [value]="
                                                    convertTimesToType(
                                                        times.sundaysFrom,
                                                        times.sundaysTo
                                                    )
                                                "
                                                (selectionChange)="
                                                    changeValidityTime(
                                                        $event,
                                                        times,
                                                        'sundays'
                                                    )
                                                "
                                                      >
                                                      <mat-option value="0">{{
                                                        "ALWAYS" | translate
                                                      }}</mat-option>
                                                      <mat-option value="1">{{
                                                        "NEVER" | translate
                                                      }}</mat-option>
                                                      <mat-option value="2">{{
                                                        "DURING_TIMES" | translate
                                                      }}</mat-option>
                                                    </mat-select>
                                                  </mat-form-field>
                                                </div>
                                                @if (
                                                  convertTimesToType(
                                                  times.sundaysFrom,
                                                  times.sundaysTo
                                                  ) === '2'
                                                  ) {
                                                  <div
                                                    class="mb-3"
                                                    >
                                                    <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'sundaysFrom')" (ngModelChange)="setTimeFromDate(times, 'sundaysFrom', $event)" [name]="'allowedSundaysFrom' + i">-->
                                                    <input
                                                      class="form-control form-control-sm"
                                                      [matTimepicker]="allowedSundaysFrom"
                                                                      [ngModel]="getTimeAsDate(times, 'sundaysFrom')" (ngModelChange)="setTimeFromDate(times, 'sundaysFrom', $event)"
                                            [name]="
                                                'allowedSundaysFrom' +
                                                i +
                                                allowedDevice.id
                                            "
                                                      />
                                                      <mat-timepicker
                                                        #allowedSundaysFrom
                                                        interval="10m"
                                                      ></mat-timepicker>
                                                      <span class="mr-2 ml-2">-</span>
                                                      <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'sundaysTo')" (ngModelChange)="setTimeFromDate(times, 'sundaysTo', $event)" [name]="'allowedSundaysTo' + i">-->
                                                      <input
                                                        class="form-control form-control-sm"
                                                        [matTimepicker]="allowedSundaysTo"
                                                                          [ngModel]="getTimeAsDate(times, 'sundaysTo')" (ngModelChange)="setTimeFromDate(times, 'sundaysTo', $event)"
                                            [name]="
                                                'allowedSundaysTo' +
                                                i +
                                                allowedDevice.id
                                            "
                                                        />
                                                        <mat-timepicker
                                                          #allowedSundaysTo
                                                          interval="10m"
                                                        ></mat-timepicker>
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                                <div class="mt-3">
                                  <strong>{{ "DENIED_DEVICES" | translate }}</strong>
                                  <div class="mt-3 mb-3">
                                    <ngx-bootstrap-multiselect
                                      class="d-inline"
                                      [texts]="multiselect.textDev"
                                      [options]="multiselect.deniedDeviceList"
                                      [settings]="multiselect.settingsDev"
                                      [(ngModel)]="addNewDeniedDeviceArray"
                                      [ngModelOptions]="{ standalone: true }"
                                      name="addNewDeniedDeviceDrp"
                                    ></ngx-bootstrap-multiselect>
                                    @if (!readOnly) {
                                    <button
                                      type="button"
                                      class="btn btn-outline-primary d-inline ml-3"
                                      (click)="addNewDeniedDevice()"
                                      >
                                      <span class="fal fa-fw fa-plus"></span>
                                      {{ "ADD_NEW" | translate }}
                                    </button>
                                    }
                                  </div>
                                  <table class="table table-striped">
                                    <thead>
                                      <tr>
                                        <th style="width: 25%">{{ "NAME" | translate }}</th>
                                        <th style="width: 25%">{{ "WEEKDAYS" | translate }}</th>
                                        <th style="width: 25%">
                                          {{ "SATURDAYS" | translate }}
                                        </th>
                                        <th style="width: 25%">{{ "SUNDAYS" | translate }}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (
                                        deniedDevice of lockBeaconConfig.deniedDevices
                                        ; track
                                        deniedDevice) {
                                        <tr
                                          [ngClass]="{ lostDevice: deniedDevice.lostDevice }"
                                          >
                                          <td>
                                            <div>
                                              {{
                                              deniedDevice.name
                                              ? deniedDevice.name +
                                              " (" +
                                              deniedDevice.id +
                                              ")"
                                              : deniedDevice.id
                                              }}
                                            </div>
                                            <div class="mt-1">
                                              <span
                                                class="fal fa-fw fa-trash-alt cursorPointerHover mr-3"
                                    (click)="
                                        removeDeniedDeviceFromList(deniedDevice)
                                    "
                                    matTooltip="{{
                                        'REMOVE_DEVICE' | translate
                                    }}"
                                                [matTooltipPosition]="'above'"
                                              ></span>
                                              @if (!isOldDevice()) {
                                                <span
                                                  class="fal fa-fw cursorPointerHover mr-3"
                                    (click)="
                                        deniedDevice.lostDevice =
                                            !deniedDevice.lostDevice
                                    "
                                    [ngClass]="
                                        deniedDevice.lostDevice
                                            ? 'fa-check'
                                            : 'fa-ban'
                                    "
                                    matTooltip="{{
                                        deniedDevice.lostDevice
                                            ? ('MARK_AS_FOUND' | translate)
                                            : ('MARK_AS_LOST' | translate)
                                    }}"
                                                  [matTooltipPosition]="'above'"
                                                ></span>
                                              }
                                              <span
                                                class="fal fa-fw fa-edit cursorPointerHover mr-1"
                                    (click)="
                                        deniedDevice.editMode =
                                            !deniedDevice.editMode
                                    "
                                                matTooltip="{{ 'EDIT_TIMES' | translate }}"
                                                [matTooltipPosition]="'above'"
                                              ></span>
                                              @if (
                                                deniedDevice.validityTimes.length < 2 &&
                                                !isOldDevice()
                                                ) {
                                                <span
                                                  (click)="addNewTimeToDevice(deniedDevice)"
                                                  class="fal fa-fw fa-plus cursorPointerHover mr-1"
                                    matTooltip="{{
                                        'ADD_NEW_TIME' | translate
                                    }}"
                                                  [matTooltipPosition]="'above'"
                                                ></span>
                                              }
                                              @if (
                                                deniedDevice.validityTimes.length ===
                                                2 && !isOldDevice()
                                                ) {
                                                <span
                                                  class="fal fa-fw fa-minus-circle cursorPointerHover"
                                    (click)="
                                        deniedDevice.validityTimes.splice(1, 1)
                                    "
                                                  matTooltip="{{ 'REMOVE_TIME' | translate }}"
                                                  [matTooltipPosition]="'above'"
                                                ></span>
                                              }
                                            </div>
                                          </td>
                                          <td>
                                            @for (
                                              times of deniedDevice.validityTimes; track
                                              times; let i = $index) {
                                              <div
                                                class="mb-2"
                                                >
                                                @if (!deniedDevice.editMode) {
                                                  <div>
                                                    @if (
                                                      convertTimesToType(
                                                      times.weekDaysFrom,
                                                      times.weekDaysTo
                                                      ) === '0'
                                                      ) {
                                                      <span
                                                        >{{ "ALWAYS" | translate }}</span
                                                        >
                                                    }
                                                    @if (
                                                      convertTimesToType(
                                                      times.weekDaysFrom,
                                                      times.weekDaysTo
                                                      ) === '1'
                                                      ) {
                                                      <span
                                                        >{{ "NEVER" | translate }}</span
                                                        >
                                                      }
                                                      @if (
                                                        convertTimesToType(
                                                        times.weekDaysFrom,
                                                        times.weekDaysTo
                                                        ) === '2'
                                                        ) {
                                                        <span
                                                          >{{ times.weekDaysFrom }} -
                                                          {{ times.weekDaysTo }}</span
                                                          >
                                                        }
                                                      </div>
                                                    }
                                                    @if (deniedDevice.editMode) {
                                                      <div
                                                        class="form-inline timeEditInputs"
                                                        >
                                                        <div>
                                                          <mat-form-field>
                                                            <mat-label>{{
                                                              "SELECT_ACTIVE_TIME" | translate
                                                            }}</mat-label>
                                                            <mat-select
                                                [value]="
                                                    convertTimesToType(
                                                        times.weekDaysFrom,
                                                        times.weekDaysTo
                                                    )
                                                "
                                                (selectionChange)="
                                                    changeValidityTime(
                                                        $event,
                                                        times,
                                                        'weekDays'
                                                    )
                                                "
                                                              >
                                                              <mat-option value="0">{{
                                                                "ALWAYS" | translate
                                                              }}</mat-option>
                                                              <mat-option value="1">{{
                                                                "NEVER" | translate
                                                              }}</mat-option>
                                                              <mat-option value="2">{{
                                                                "DURING_TIMES" | translate
                                                              }}</mat-option>
                                                            </mat-select>
                                                          </mat-form-field>
                                                        </div>
                                                        @if (
                                                          convertTimesToType(
                                                          times.weekDaysFrom,
                                                          times.weekDaysTo
                                                          ) === '2'
                                                          ) {
                                                          <div
                                                            class="mb-3"
                                                            >
                                                            <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'weekDaysFrom')" (ngModelChange)="setTimeFromDate(times, 'weekDaysFrom', $event)" [name]="'deniedWeekDaysFrom' + i">-->
                                                            <input
                                                              class="form-control form-control-sm"
                                                              [matTimepicker]="deniedWeekDaysFrom"
                                                                                      [ngModel]="getTimeAsDate(times, 'weekDaysFrom')" (ngModelChange)="setTimeFromDate(times, 'weekDaysFrom', $event)"
                                            [name]="
                                                'deniedWeekDaysFrom' +
                                                i +
                                                deniedDevice.id
                                            "
                                                              />
                                                              <mat-timepicker
                                                                #deniedWeekDaysFrom
                                                                interval="10m"
                                                              ></mat-timepicker>
                                                              <span class="mr-2 ml-2">-</span>
                                                              <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'weekDaysTo')" (ngModelChange)="setTimeFromDate(times, 'weekDaysTo', $event)" [name]="'deniedWeekDaysTo' + i">-->
                                                              <input
                                                                class="form-control form-control-sm"
                                                                [matTimepicker]="deniedWeekDaysTo"
                                                                                          [ngModel]="getTimeAsDate(times, 'weekDaysTo')" (ngModelChange)="setTimeFromDate(times, 'weekDaysTo', $event)"
                                            [name]="
                                                'deniedWeekDaysTo' +
                                                i +
                                                deniedDevice.id
                                            "
                                                                />
                                                                <mat-timepicker
                                                                  #deniedWeekDaysTo
                                                                  interval="10m"
                                                                ></mat-timepicker>
                                                              </div>
                                                            }
                                                          </div>
                                                        }
                                                      </div>
                                                    }
                                                  </td>
                                                  <td>
                                                    @for (
                                                      times of deniedDevice.validityTimes; track
                                                      times; let i = $index) {
                                                      <div
                                                        class="mb-2"
                                                        >
                                                        @if (!deniedDevice.editMode) {
                                                          <div>
                                                            @if (
                                                              convertTimesToType(
                                                              times.saturdaysFrom,
                                                              times.saturdaysTo
                                                              ) === '0'
                                                              ) {
                                                              <span
                                                                >{{ "ALWAYS" | translate }}</span
                                                                >
                                                            }
                                                            @if (
                                                              convertTimesToType(
                                                              times.saturdaysFrom,
                                                              times.saturdaysTo
                                                              ) === '1'
                                                              ) {
                                                              <span
                                                                >{{ "NEVER" | translate }}</span
                                                                >
                                                              }
                                                              @if (
                                                                convertTimesToType(
                                                                times.saturdaysFrom,
                                                                times.saturdaysTo
                                                                ) === '2'
                                                                ) {
                                                                <span
                                                                  >{{ times.saturdaysFrom }} -
                                                                  {{ times.saturdaysTo }}</span
                                                                  >
                                                                }
                                                              </div>
                                                            }
                                                            @if (deniedDevice.editMode) {
                                                              <div
                                                                class="form-inline timeEditInputs"
                                                                >
                                                                <div>
                                                                  <mat-form-field>
                                                                    <mat-label>{{
                                                                      "SELECT_ACTIVE_TIME" | translate
                                                                    }}</mat-label>
                                                                    <mat-select
                                                [value]="
                                                    convertTimesToType(
                                                        times.saturdaysFrom,
                                                        times.saturdaysTo
                                                    )
                                                "
                                                (selectionChange)="
                                                    changeValidityTime(
                                                        $event,
                                                        times,
                                                        'saturdays'
                                                    )
                                                "
                                                                      >
                                                                      <mat-option value="0">{{
                                                                        "ALWAYS" | translate
                                                                      }}</mat-option>
                                                                      <mat-option value="1">{{
                                                                        "NEVER" | translate
                                                                      }}</mat-option>
                                                                      <mat-option value="2">{{
                                                                        "DURING_TIMES" | translate
                                                                      }}</mat-option>
                                                                    </mat-select>
                                                                  </mat-form-field>
                                                                </div>
                                                                @if (
                                                                  convertTimesToType(
                                                                  times.saturdaysFrom,
                                                                  times.saturdaysTo
                                                                  ) === '2'
                                                                  ) {
                                                                  <div
                                                                    class="mb-3"
                                                                    >
                                                                    <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'saturdaysFrom')" (ngModelChange)="setTimeFromDate(times, 'saturdaysFrom', $event)" [name]="'deniedSaturdaysfrom' + i">-->
                                                                    <input
                                                                      class="form-control form-control-sm"
                                            [matTimepicker]="
                                                deniedSaturdaysfrom
                                            "
                                                                                                      [ngModel]="getTimeAsDate(times, 'saturdaysFrom')" (ngModelChange)="setTimeFromDate(times, 'saturdaysFrom', $event)"
                                            [name]="
                                                'deniedSaturdaysfrom' +
                                                i +
                                                deniedDevice.id
                                            "
                                                                      />
                                                                      <mat-timepicker
                                                                        #deniedSaturdaysfrom
                                                                        interval="10m"
                                                                      ></mat-timepicker>
                                                                      <span class="mr-2 ml-2">-</span>
                                                                      <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'saturdaysTo')" (ngModelChange)="setTimeFromDate(times, 'saturdaysTo', $event)" [name]="'deniedSaturdaysTo' + i">-->
                                                                      <input
                                                                        class="form-control form-control-sm"
                                                                        [matTimepicker]="deniedSaturdaysTo"
                                                                                                          [ngModel]="getTimeAsDate(times, 'saturdaysTo')" (ngModelChange)="setTimeFromDate(times, 'saturdaysTo', $event)"
                                            [name]="
                                                'deniedSaturdaysTo' +
                                                i +
                                                deniedDevice.id
                                            "
                                                                        />
                                                                        <mat-timepicker
                                                                          #deniedSaturdaysTo
                                                                          interval="10m"
                                                                        ></mat-timepicker>
                                                                      </div>
                                                                    }
                                                                  </div>
                                                                }
                                                              </div>
                                                            }
                                                          </td>
                                                          <td>
                                                            @for (
                                                              times of deniedDevice.validityTimes; track
                                                              times; let i = $index) {
                                                              <div
                                                                class="mb-2"
                                                                >
                                                                @if (!deniedDevice.editMode) {
                                                                  <div>
                                                                    @if (
                                                                      convertTimesToType(
                                                                      times.sundaysFrom,
                                                                      times.sundaysTo
                                                                      ) === '0'
                                                                      ) {
                                                                      <span
                                                                        >{{ "ALWAYS" | translate }}</span
                                                                        >
                                                                    }
                                                                    @if (
                                                                      convertTimesToType(
                                                                      times.sundaysFrom,
                                                                      times.sundaysTo
                                                                      ) === '1'
                                                                      ) {
                                                                      <span
                                                                        >{{ "NEVER" | translate }}</span
                                                                        >
                                                                      }
                                                                      @if (
                                                                        convertTimesToType(
                                                                        times.sundaysFrom,
                                                                        times.sundaysTo
                                                                        ) === '2'
                                                                        ) {
                                                                        <span
                                                                          >{{ times.sundaysFrom }} -
                                                                          {{ times.sundaysTo }}</span
                                                                          >
                                                                        }
                                                                      </div>
                                                                    }
                                                                    @if (deniedDevice.editMode) {
                                                                      <div
                                                                        class="form-inline timeEditInputs"
                                                                        >
                                                                        <div>
                                                                          <mat-form-field>
                                                                            <mat-label>{{
                                                                              "SELECT_ACTIVE_TIME" | translate
                                                                            }}</mat-label>
                                                                            <mat-select
                                                [value]="
                                                    convertTimesToType(
                                                        times.sundaysFrom,
                                                        times.sundaysTo
                                                    )
                                                "
                                                (selectionChange)="
                                                    changeValidityTime(
                                                        $event,
                                                        times,
                                                        'sundays'
                                                    )
                                                "
                                                                              >
                                                                              <mat-option value="0">{{
                                                                                "ALWAYS" | translate
                                                                              }}</mat-option>
                                                                              <mat-option value="1">{{
                                                                                "NEVER" | translate
                                                                              }}</mat-option>
                                                                              <mat-option value="2">{{
                                                                                "DURING_TIMES" | translate
                                                                              }}</mat-option>
                                                                            </mat-select>
                                                                          </mat-form-field>
                                                                        </div>
                                                                        @if (
                                                                          convertTimesToType(
                                                                          times.sundaysFrom,
                                                                          times.sundaysTo
                                                                          ) === '2'
                                                                          ) {
                                                                          <div
                                                                            class="mb-3"
                                                                            >
                                                                            <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'sundaysFrom')" (ngModelChange)="setTimeFromDate(times, 'sundaysFrom', $event)" [name]="'deniedSundaysFrom' + i">-->
                                                                            <input
                                                                              class="form-control form-control-sm"
                                                                              [matTimepicker]="deniedSundaysFrom"
                                                                                                                      [ngModel]="getTimeAsDate(times, 'sundaysFrom')" (ngModelChange)="setTimeFromDate(times, 'sundaysFrom', $event)"
                                            [name]="
                                                'deniedSundaysFrom' +
                                                i +
                                                deniedDevice.id
                                            "
                                                                              />
                                                                              <mat-timepicker
                                                                                #deniedSundaysFrom
                                                                                interval="10m"
                                                                              ></mat-timepicker>
                                                                              <span class="mr-2 ml-2">-</span>
                                                                              <!--<input pattern="^([0-9]{2}):([0-9]{2})$" type="text" class="form-control form-control-sm" [ngModel]="getTimeAsDate(times, 'sundaysTo')" (ngModelChange)="setTimeFromDate(times, 'sundaysTo', $event)" [name]="'deniedSundaysTo' + i">-->
                                                                              <input
                                                                                class="form-control form-control-sm"
                                                                                [matTimepicker]="deniedSundaysTo"
                                                                                                                          [ngModel]="getTimeAsDate(times, 'sundaysTo')" (ngModelChange)="setTimeFromDate(times, 'sundaysTo', $event)"
                                            [name]="
                                                'deniedSundaysTo' +
                                                i +
                                                deniedDevice.id
                                            "
                                                                                />
                                                                                <mat-timepicker
                                                                                  #deniedSundaysTo
                                                                                  interval="10m"
                                                                                ></mat-timepicker>
                                                                              </div>
                                                                            }
                                                                          </div>
                                                                        }
                                                                      </div>
                                                                    }
                                                                  </td>
                                                                </tr>
                                                              }
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </form>
                                                      <div class="form-group mt-3">
                                                        @if (saveSuccess) {
                                                          <div class="alert alert-success">
                                                            {{ "DEVICE_INFORMATION_UPDATED" | translate }}
                                                          </div>
                                                        }
                                                        @if (saveError) {
                                                          <div class="alert alert-danger">
                                                            {{ "ERROR" | translate }}
                                                          </div>
                                                        }
                                                        @if (!readOnly) {
                                                        <button
                                                          [disabled]="allowedDeniedForm.form.invalid"
                                                          type="button"
                                                          class="btn btn-primary"
                                                          (click)="submitLockBeaconSettings()"
                                                          >
                                                          {{ "SAVE" | translate }}
                                                        </button>
                                                        }
                                                      </div>
                                                    </div>
                                                  }
